<template>
    <div>       
        <b-tabs v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Negocios</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 0">
                    <terceros-lista  @tabindex="changeTab"></terceros-lista>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Vehículos</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 1">
                    <Negocios_Vehiculos  @tabindex="changeTab"></Negocios_Vehiculos >
                </template>
            </b-tab>
            <!-- <template v-if="mostrarOcultarGuia == 1"> -->
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Conductor</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 2">
                    <Negocios_Conductor  @tabindex="changeTab"></Negocios_Conductor >
                </template>
            </b-tab>
            <!-- </template> -->
        </b-tabs>
    </div>
</template>
<script>
import TercerosLista from '@/components/gestion/TercerosLista'
import Negocios_Vehiculos from '@/components/gestion/Negocios_Vehiculos'
import Negocios_Conductor from '@/components/gestion/Negocios_Conductor'
import Negocios_EntidadEmisora from '@/components/gestion/Negocios_EntidadEmisora'

export default {
    name: 'Terceros',
    components: {
        'terceros-lista': TercerosLista,
        Negocios_Vehiculos,
        Negocios_Conductor,
        Negocios_EntidadEmisora
    },
    data: () => {
        return {
            tabIndex: 0,
            mostrarOcultarGuia:''
        }
    },
    mounted(){
    //this.ocultarGuiaTransportista
    },
    methods: {
        changeTab(value){
            this.tabIndex = value
        },
        // ocultarGuiaTransportista(){
        //     this.mostrarOcultarGuia = this.$store.getters.guiaTransportista
        // }
    }
    
}
</script>

<style>

</style>